import { createSelector } from 'reselect'
import { createGetter, composeGetters } from 'react-redux-getters'
import { getCollection, replaceCollections, replaceEntities, getEntity } from '@fakundo/redux-entities'
import keyBy from 'lodash/keyBy'
import find from 'lodash/find'
import { ALL_REQUESTS, REQUESTS } from 'constants/entityNames'
import { fetchRequests, fetchRequest } from 'actions/requests'
import { getProposals } from 'selectors/proposals'

export const getRequests = createGetter({
  stateSelector: state => getCollection(state, ALL_REQUESTS),
  asyncFetcher: dispatch => dispatch(fetchRequests()),
  stateUpdater: (requests, dispatch) => dispatch(replaceCollections({
    [ALL_REQUESTS]: keyBy(requests, 'id')
  })),
})

export const getRequest = createGetter({
  stateSelector: (state, params) => getEntity(state, REQUESTS, params.requestId),
  asyncFetcher: (dispatch, state, params) => dispatch(fetchRequest(params.requestId)),
  stateUpdater: (request, dispatch) => dispatch(replaceEntities(REQUESTS, {
    [request.id]: request
  })),
})

export const getRequestProposal = createSelector(
  getRequest,
  state => getProposals(state),
  (requestGetter, proposalsGetter) => composeGetters(
    requestGetter,
    proposalsGetter,
    (requestGetterData, proposalsGetterData) => find(proposalsGetterData, {
      id: requestGetterData.proposalId
    })
  )
)
